<template>
  <div>
    <iModal
      title="新建项目"
      v-model="showModal"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
      @on-cancel="cancel"
      style="overflow:auto"
    >
      <div class="project-add">
        <div class="project-add-content">
          <Form
            ref="formInline"
            :model="formInline"
            :rules="ruleInline"
            label-position="right"
            :label-width="100"
            @submit.native.prevent
          >
            <FormItem label="项目类型：" prop="type">
              <RadioGroup v-model="formInline.type">
                <Radio label="展会" border></Radio>
                <Radio label="会议" border></Radio>
                <Radio label="节事" border></Radio>
                <Radio label="线上" border></Radio>
            </RadioGroup>
            </FormItem>
            <FormItem label="展会logo：" prop="logo">
              <div class="my-upload">
                <div
                  class="my-upload-list"
                  v-for="(item, index) in uploadList"
                  :key="'upload' + index"
                >
                  <template v-if="item.status === 'finished'">
                    <img :src="item.url" style="width: 100px;height: 100px;" />
                    <div class="my-upload-list-cover">
                      <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
                      <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemove(item)"></Icon>
                    </div>
                  </template>
                  <template v-else>
                    <Spin v-if="item.showProgress" style="width: 100px;height: 100px;">
                      <Icon type="ios-loading" size=20 class="demo-spin-icon-load"></Icon>
                    </Spin>
                  </template>
                </div>
                <Upload
                  ref="upload"
                  :show-upload-list="false"
                  :default-file-list="defaultList"
                  :on-success="handleSuccess"
                  :format="['jpg','jpeg','png']"
                  :max-size="2048"
                  :headers="formHeaders"
                  :on-format-error="handleFormatError"
                  :on-exceeded-size="handleMaxSize"
                  :before-upload="handleBeforeUpload"
                  multiple
                  type="drag"
                  :action="uploadUrl"
                  style="display: inline-block;"
                  v-show="uploadList && uploadList.length < 1"
                >
                  <div style="width:100px;height:100px;padding-top: 18px;color:rgb(133, 133, 133)">
                    <div style="font-size:25px">
                      +
                      <p style="font-size:14px">上传</p>
                    </div>
                  </div>
                </Upload>
                <iModal title="图片查看" cancel-text v-model="visible">
                  <div style="text-align: center;">
                    <img :src="imgName" v-if="visible" style="max-width: 100%" />
                  </div>
                </iModal>
              </div>
              <p class="upload-p" style="display:block;font-size:12px;">(图片要求：2M以下的jpg或png，建议尺寸为120*120px)</p>
            </FormItem>
            <FormItem label="展会全称：" prop="name">
              <Input v-model="formInline.name" placeholder="请输入展会全称" />
            </FormItem>
            <FormItem label="展会时间：" prop="exdate">
              <DatePicker
                type="datetimerange"
                format="yyyy-MM-dd"
                placeholder="请选择展会时间"
                style="width: 100%;"
                v-model="exDate"
                @on-change="dateChange"
              ></DatePicker>
            </FormItem>
            <FormItem label="举办城市：" required>
              <Row type="flex" justify="space-between">
                <Col span="11">
                  <FormItem prop="province">
                    <Select
                      v-model="formInline.province"
                      placeholder="请选择省份"
                      @on-change="changeProvince"
                    >
                      <Option
                        v-for="(item, index) in provinceArr"
                        :key="item.value"
                        :value="item.value"
                      >{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                </Col>
                <Col span="11">
                  <FormItem prop="city">
                    <Select
                      v-model="formInline.city"
                      placeholder="请选择城市"
                      @on-change="changeCity"
                    >
                      <Option
                        v-for="(item, index) in citiesArr"
                        :key="item.value"
                        :value="item.value"
                      >{{ item.label }}</Option>
                    </Select>
                  </FormItem>
                </Col>
              </Row>
            </FormItem>
            <FormItem label="举办地址：" prop="address">
              <Input v-model="formInline.address" placeholder="请输入展会举办地址" />
            </FormItem>
            <FormItem label="举办场馆：" prop="exHall">
              <Input v-model="formInline.exHall" placeholder="请输入举办场馆" />
            </FormItem>
            <FormItem label="展会简介：">
              <customComponentCommon v-model="formInline.introduction" :type="2" @change="changModal"></customComponentCommon>
            </FormItem>
          </Form>
        </div>
      </div>
      <div slot="footer">
        <Button type="primary" :loading="loading" @click="handleSubmit('formInline')">确认</Button>
        <Button @click="cancel">取消</Button>
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { provinces } from "@/other/provinces";
import customComponentCommon from "@components/custom-component/custom-component-common.vue";

export default {
  name: "project-add",
  props: {
    show: {
      type: Boolean,
      default: false
    }, 
  },
  data() {
    const that = this;
    const typeReg = (rule, value, callback) => {
      if (!that.formInline.type) {
        callback(new Error("请选择展会类型"));
      } else {
        callback();
      }
    };
    const logoReg = (rule, value, callback) => {
      if (that.uploadList && that.uploadList.length) {
        callback();
      } else {
        callback(new Error("请上传展会Logo"));
      }
    };
    const exDateReg = (rule, value, callback) => {
      if (!that.exDate[0] || !that.exDate[1]) {
        callback(new Error("请选择展会时间"));
      } else {
        callback();
      }
    };
    return {
      AgentId: "CD4E8CEF-C6F7-4E72-9132-93161B9E8C43",
      loading: false,
      showModal: false,
      time: [],
      formInline: {
        type: "", // 项目类型
        name: "", // 展会全称
        address: "", // 举办地点
        exHall: "", // 举办场馆
        introduction: [], // 展会简介
        province: "", // 省
        city: "", // 市
      },
      ruleInline: {
        type: [{ required: true, validator: typeReg, trigger: "change" }],
        logo: [{ required: true, validator: logoReg, trigger: "change" }],
        name: [{ required: true, message: "请输入展会全称", trigger: "blur" }],
        exdate: [{ required: true, validator: exDateReg, trigger: "change" }],
        address: [{ required: true, message: "请输入举办地址", trigger: "blur" }],
        exHall: [{ required: true, message: "请输入举办场馆", trigger: "blur" }],
        province: [{ required: true, message: "请选择举办省份", trigger: "change" }],
        city: [{ required: true, message: "请选择举办城市", trigger: "change" }],
      },
      uploadList: [], // 展会logo
      defaultList: [],
      imgName: "",
      visible: false,
      exDate: [], // 展会时间
      provinceArr: [],
      citiesArr: [],
    };
  },
  watch: {
    show(val, oldVal) {
      this.showModal = val;
      if (!val) this.$emit("close");
    }
  },
  computed: {
    ...mapGetters({
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
    }),
  },
  created() {
    this.provinceArr = provinces.data;
  },
  methods: {
    ...mapActions({
      transformReqCustomData: "customComponentModule/transformReqCustomData",
      addEx: "hostSetModule/addEx"
    }),
    // 查看上传图片
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    // 移除上传图片
    handleRemove(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    // 上传成功
    handleSuccess(res, file) {
        console.log(res,'res');
        console.log(file,'file');
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    // 文件格式错误
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    // 文件过大
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    // 上传数量
    handleBeforeUpload() {
      const limitNum = 1;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    changModal($event) {
      this.formInline.introduction = $event;
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
      if (!valid) return;

      let ShowType = "";
      if (this.formInline.type == '展会') {
        ShowType = 0;
      } else if (this.formInline.type == '会议') {
        ShowType = 1;
      } else if (this.formInline.type == '节事') {
        ShowType = 2;
      } else if (this.formInline.type == '线上') {
        ShowType = -1;
      }
      
      let startTime = "";
      let endTime = "";
      if (!this.exDate[0] || !this.exDate[1]) {
        this.$Message.warning("请选择展会时间");
        return;
      } else {
        startTime = this.exDate[0];
        endTime = this.exDate[1];
      }

      // 简介
      let Introduction = await this.transformReqCustomData(this.formInline.introduction);
      if (!Introduction || Introduction === "[]") {
        this.$Message.error("请完善简介信息");
        return;
      }

      let req = {
        AgentId: this.AgentId,
        ShowType: ShowType,
        Logo: this.uploadList[0].url,
        Name: this.formInline.name,
        StartTime: startTime,
        EndTime: endTime,
        Province: this.formInline.province,
        City: this.formInline.city,
        Address: this.formInline.address,
        ExHall: this.formInline.exHall,
        Introduction: Introduction
      };
      console.log(req)
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let bool = await this.addEx(req).catch(err => {
        this.loading = false;
      });
      if (!bool) {
        this.loading = false;
        this.$Message.error("添加失败，请重新尝试");
      } else {
        this.$emit("finish");
        this.$Message.success("添加成功！");
        this.cancel();
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.uploadList = [];
      this.$refs.upload.fileList = [];
      this.exDate = [];
      this.formInline.introduction = [];
      this.$emit("close");
    },
    dateChange(e) {
      this.exDate = e;
    },
    changeProvince(val) {
      // this.formInline.city = this.company.city || "";
      for (var i = 0; i < this.provinceArr.length; i++) {
        if (val == this.provinceArr[i].value) {
          this.citiesArr = this.provinceArr[i].children;
          this.countyArr = [];
        }
      }
    },
    changeCity(val) {
      for (var i = 0; i < this.citiesArr.length; i++) {
        if (val == this.citiesArr[i].value) {
          this.countyArr = this.citiesArr[i].children;
        }
      }
    },
  },
  components: {
    customComponentCommon
  }
};
</script>

<style lang="scss">
.project-add {
  .ivu-radio {
    display: none;
  }
}
</style>
<style scoped lang="scss">
.project-add {
  &-content {
    padding: 20px 40px 20px 20px;
  }
}
.project-add {
  &-title {
    width: 100%;
    text-align: center;
    margin-bottom: 20px;
    font-size: 16px;
  }
  &-content {
    .submit {
      display: flex;
      justify-content: center;
      button {
        margin-left: -75px;
      }
    }
    img {
      width: 150px;
      height: 150px;
    }
  }
  .form-code-item {
    position: relative;
    .form-code-btn {
      position: absolute;
      right: 1px;
      width: 96px;
      top: 2px;
      border: none;
      outline: none;
      &:focus {
        box-shadow: none;
        border: none;
        outline: none;
      }
    }
  }
}
</style>

